module.exports = __webpack_public_path__ + "img/DFM.dba145f6.svg";